import React from 'react'
import { connect } from 'react-redux'
import TransferHistoryActions from '../../Redux/TransferHistoryRedux'

class MatchManualForm extends React.Component {
  constructor (props) {
    super (props)
    this.dateFormat = 'DD MMM YYYY, h:mm:ss a'
    this.state = {
      full_name: props.detail.account_name,
      transfer_amount: props.detail.amount,
      order_number: '',
      process_status: 'manual-confirm',
      note: ''
    }
  }

  _submit = (event) => {
    if (event) event.preventDefault()
    const {
      order_number,
      process_status,
      transfer_amount,
      note
    } = this.state

    const data = {
      id: this.props.detail.id,
      form: {
        order_number,
        process_status,
        transfer_amount,
        note
      }
    }
    this.props.update(data)
    this.props.closeModal()
  }

  render() {
    const { transfer_history, detail } = this.props

    // let order_list = []
    // detail.orders.length && detail.orders.map((item, i) => {
    //   order_list.push({
    //     value: item.id,
    //     label: `[ ${item.order_number} ] - ${item.amount}`
    //   })
    //   return order_list
    // })

    return (
      <form onSubmit={(event) => this._submit(event)} className="section" style={{ width: '30vw' }}>
        <header className="title-block">
          <h4 className="title mr-auto">
            Manual <div className="badge badge-dark ml-2">{detail.seq_no || '-'}</div> 
            {(transfer_history.fetching || transfer_history.processing) && 
              <div className="badge badge-info ml-2">{transfer_history.fetching ? 'Loading' : 'Processing'} ...</div> 
            }
          </h4>
        </header>
        <section className="section">
          <div className="form-group">
            <label className="control-label">Full Name</label>
            <input type="text" className="form-control" readOnly value={this.state.full_name}/>
          </div>

          <div className="form-group">
            <label className="control-label">Transfer Amount</label>
            {/* <input type="number" className="form-control" readOnly value={this.state.transfer_amount}/> */}
            <input type="number" readOnly className="form-control" placeholder="Transfer Amount" value={this.state.transfer_amount} onChange={(event) => this.setState({ transfer_amount: event.target.value })} />
          </div>

          <div className="form-group">
            <label className="control-label">Order Number</label>
            <input type="text" className="form-control" placeholder="Order Number" value={this.state.order_number} onChange={(event) => this.setState({ order_number: event.target.value })}/>
          </div>

          <div className="form-group">
            <label className="control-label">Notes (Optional)</label>
            <textarea className="form-control" value={this.state.note} placeholder="Notes" onChange={(event) => this.setState({ note: event.target.value })}/>
          </div>
        </section>

        <div className="text-right">
          <button type="button" className="btn btn-lg btn-secondary mr-2" onClick={() => this.props.closeModal()}>Close</button>
          <button type="submit" className="btn btn-lg btn-primary">Save</button>
        </div>
      </form>
    )
  }
}

const stateToProps = (state) => ({
  transfer_history: state.transfer_history
})

const dispatchToProps = (dispatch) => ({
  update: (data) => dispatch(TransferHistoryActions.transferHistoryUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(MatchManualForm)



// WEBPACK FOOTER //
// ./src/Containers/Order/MatchManualForm.js